import { ReadMore } from 'app/src/features/ProductDetail/components/ReadMore'
import { replaceUrlInString } from 'app/src/shared/helpers'
import { type ReactElement } from 'react'

export type ProductInformativeMetadataPropsType = {
  informativeMetadata?: {
    [key: string]: string
  }
  multiPurchase: boolean
  variantName: string | undefined
}

export function ProductInformativeMetadata(props: ProductInformativeMetadataPropsType): ReactElement {
  if (props.informativeMetadata && Object.keys(props.informativeMetadata).length !== 0)
    return (
      <div className='rounded-[8px] border-[1px] border-[#0047BB] px-[36px] py-[16px]' data-testid='ProductInformativeMetadata'>
        <ul className='list-disc'>
          {Object.keys(props.informativeMetadata).map((key) => (
            <ReadMore key={key + props.variantName} title={key} textUrl={replaceUrlInString(props.informativeMetadata?.[key])} />
          ))}
        </ul>
      </div>
    )
  else return <></>
}
